<template>
  <div class="mt-8">

    <v-card-text>
      <div class="row justify-center align-content-start">
        <div class="col-12">
          <v-textarea
            filled
            auto-grow
            label="Add Note (Ctrl + Enter)"
            rows="3"
            placeholder="Add a note ..."
            outlined
            v-model="addNoteInput.noteMessage"
            append-icon="mdi-send"
            @keypress.ctrl.enter="addNote"
            @click:append="addNote"
            hint="Press CTRL + ENTER"
          >
          </v-textarea>
        </div>
      </div>
      <div>
        <v-list two-line>
          <template v-for="(note, index) in notesList">
            <f-comment
              :key="`note${index}`"
              :createdBy="note.createdBy"
              :createdOn="note.createdOn"
              :noteMessage="note.noteMesssage"
            />

            <v-divider
              v-if="index < fiNoteList.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </div>
    </v-card-text>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
// import * as ServerData from '@/../src-gen/server-data';
import * as Action from "@/../src-gen/action";
import ModelVue from "@/components/ModelVue";
import FBtn from "@/components/FBtn.vue";
import FComment from "@/components/FComment.vue";
import FSnackbar from "@/fsnackbar";

@Component({
  components: {
    "f-btn": FBtn,
    FComment,
  },
})
export default class NotesList extends ModelVue {
  @Prop({ default: () => new Data.Spine.GetCustomerDetailsChppOutput() })
  customerDetailsNotes: Data.Spine.GetCustomerDetailsChppOutput;
    @Prop()
    notesAdded: () => void;
  addNoteInput: Data.Spine.AddNoteInput = new Data.Spine.AddNoteInput();

  mounted() {}
    get notesList() {
        return this.customerDetailsNotes.fiNotesList.filter(item => {
            return item.tagList.findIndex(tag => tag.tagKey==="chpp-notes")!==-1
        }).reverse();
    }
  addNote() {
    FSnackbar.confirm({
      message: "Are you sure want to add the note",
      onConfirm: () => {
        this.addNoteInput.clientFileId = this.customerDetailsNotes.clientFileId;
        this.addNoteInput.noteTagList = [new Data.Spine.FiNoteTag("chpp-notes","chpp-notes")]
        Action.Spine.AddNote.execute(this.addNoteInput, (output) => {
          FSnackbar.success("Succesfully added the note");
          this.addNoteInput = new Data.Spine.AddNoteInput();
          this.notesAdded();
        });
      },
    });
  }
}
</script>

<style></style>
